import { Box, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { shadow } from '../../theme/designTokens'
import { HOME_MOBILE_MQ } from './homeMobileLayout'

/** Figma mobile 76:3418 — 362×200; desktop 1:2642 — 480×580 */
const MOBILE_IMAGE_ASPECT = '362 / 200'
const DESKTOP_IMAGE_ASPECT = '480 / 580'
const CARD_SHADOW_HOVER = '0px 4px 20px 0px rgba(0,0,0,0.16)'

export default function HomeStoryCard({ title, date, image, to = '/stories' }) {
  return (
    <Box
      component={RouterLink}
      to={to}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
        width: '100%',
        minWidth: 0,
        textDecoration: 'none',
        color: 'inherit',
        '&:hover .home-story-card__image': {
          boxShadow: CARD_SHADOW_HOVER,
          transform: 'translateY(-2px)',
        },
        '&:hover .home-story-card__image img': {
          transform: 'scale(1.05)',
        },
      }}
    >
      <Box
        className="home-story-card__image"
        sx={{
          position: 'relative',
          width: '100%',
          minWidth: 0,
          aspectRatio: {
            xs: MOBILE_IMAGE_ASPECT,
            md: DESKTOP_IMAGE_ASPECT,
          },
          borderRadius: { xs: '16px', md: '20px' },
          overflow: 'hidden',
          bgcolor: '#fffefa',
          boxShadow: shadow.card,
          flexShrink: 0,
          transition: 'box-shadow 0.3s ease, transform 0.3s ease',
          [HOME_MOBILE_MQ]: {
            aspectRatio: MOBILE_IMAGE_ASPECT,
            borderRadius: '16px',
          },
        }}
      >
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block',
            transition: 'transform 0.4s ease',
          }}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          width: '100%',
          minWidth: 0,
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: 22, md: 24 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: '#111',
            wordBreak: 'break-word',
            [HOME_MOBILE_MQ]: { fontSize: 22 },
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: 15, md: 16 },
            lineHeight: 'normal',
            fontWeight: 400,
            color: 'rgba(17,17,17,0.8)',
            [HOME_MOBILE_MQ]: { fontSize: 15 },
          }}
        >
          {date}
        </Typography>
      </Box>
    </Box>
  )
}
